import { z } from 'zod'

export const archiveQuerySchema = z.object({
  bookId: z.string().optional(),
  tagIds: z.string().optional(), // Comma-separated tag IDs
})

export type ArchiveQueryInput = z.infer<typeof archiveQuerySchema>
